const INITIAL_STATE = {
  purchaseOptions: [],
  cart: [],
  purchaseItemFilter: '',
  loaded: false
};

export const eventsPurchaseReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'INITIALIZE_EVENTS_PURCHASE_PAGE': {
      return {
        ...state,
        purchaseOptions: action.payload,
        loaded: true
      };
    }
    case 'EVENTS_PURCHASE_PAGE_UPDATE_CART':
      return {
        ...state,
        cart: action.payload
      };
    case 'EVENTS_PURCHASE_PAGE_UPDATE_FILTER_STRING':
      return {
        ...state,
        purchaseItemFilter: action.payload
      };
    case 'CLEAR_EVENTS_PURCHASE_PAGE':
      return INITIAL_STATE;
    default:
      return state;
  }
};
